export type ParamValue = string | boolean | number | Array<string | number> | undefined;

export class ApiParams {
  constructor(public json: { [key: string]: ParamValue }) {}

  get stringified(): string {
    const keys = Object.keys(this.json);
    return keys.length > 0
      ? `?${keys
          .map(key => {
            if (this.json[key] !== undefined) {
              let value = Array.isArray(this.json[key])
                ? (this.json[key] as Array<string | number>).join(",")
                : this.json[key]!.toString();
              return `${key}=${encodeURIComponent(value)}`;
            }
          })
          .filter(params => params !== undefined)
          .join("&")}`
      : "";
  }
}



// WEBPACK FOOTER //
// ./app/backend/apiParams.ts